import qs from "qs";
import cookies from "js-cookie";

import { root } from "@constants/navlinks";
import { ACCESS_TOKEN } from "@constants/common";
import { getUserToken } from "@api/actions/auth";

import type { GetUserTokenDto } from "@interfaces/auth";

export const signIn = async (
  formData: GetUserTokenDto,
  redirectUrl?: string,
  withRedirect = true,
) => {
  const payload = {
    login: formData.login,
    password: formData.password,
  };

  try {
    let href: string = root;

    const response = await getUserToken(payload);

    cookies.set(ACCESS_TOKEN, response.data.accessToken);

    if (redirectUrl) {
      const { path, ...rest } = qs.parse(redirectUrl);
      const query = qs.stringify(rest);

      href = `${path}?${query}`;
    }

    if (withRedirect) window.location.href = href;
  } catch (err) {
    console.error(err);
  }
};
